import styled from "styled-components"

export const StyledDiv = styled.div`
position: absolute;
display:flex;
justify-content: center;
align-items: center;
flex-direction: column;
transform: translateX(-50%);
top: 110px;

width: 900px;
height: 400px;
background-color: black;
color:white;
padding: 20;
font-size: 40px;
z-index: 1;

`

export const GameOverButton = styled.button `
  background-color: yellow;
  background-image: none;
  border: 1px solid #000;
  border-radius: 4px;
  box-shadow: orange 4px 4px 0 0,#000 4px 4px 0 1px;
  box-sizing: border-box;
  color: #000;
  cursor: pointer;
  display: inline-block;
  font-family: Arial,sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0 5px 10px 0;
  padding: 12px 40px;
  text-align: center;
`

export const WinningButton= styled.button `
  background-color: yellow;
  border: 1px solid #000;
  border-radius: 4px;
  box-shadow: orange 4px 4px 0 0,#000 4px 4px 0 1px;
  box-sizing: border-box;
  color: #000;
  cursor: pointer;
  display: inline-block;
  font-family: Arial,sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0 5px 10px 0;
  overflow: visible;
  padding: 12px 40px;
  text-align: center;
  margin-top: 1rem;



`









